// extracted by mini-css-extract-plugin
module.exports = {"omniFooterFadeIn":"index-omniFooterFadeIn-2CM5V"};